<!--部队模块-->
<template>
  <div class="xz_module_publish">
    <div class="draft-job">
      <h5>部队要求</h5>
    </div>
    <div class="infor_field">
      <label class="field_name must_star" :class="{'emptyError': strArmyAge.check}">军龄：</label>
      <div class="value_part">
        <div class="eduContainer">
          <el-radio-group v-model="strArmyAge.value" @change="changeCheck('strArmyAge')">
            <el-radio-button v-for="(tag,index) in armyAge" :key="index" :label="tag">{{tag}}
            </el-radio-button>
          </el-radio-group>
        </div>
        <p v-if="strArmyAge.check" class="emptyWarn">请选择军龄</p>
      </div>
    </div>
    <div class="infor_field flexStart">
      <label class="field_name must_star" :class="{'emptyError': majorItems.check}">军队专业：</label>
        <div class="value_part">
          <MultipleSelect :custom="true" customlabel="新增专业" :options="armyMajor" :selected="majorItems.value" @change="selectMajor"></MultipleSelect>
          <p v-if="majorItems.check" class="emptyWarn">请选择军队专业</p>
        </div>
    </div>
    
    <div class="infor_field">
      <label class="field_name must_star" :class="{'emptyError': strArmyTitle.check}">职务：</label>
      <div class="value_part">
        <div class="eduContainer">
          <el-radio-group v-model="strArmyTitle.value" @change="changeCheck('strArmyTitle')">
            <el-radio-button v-for="(tag,index) in armyRole" :key="index" :label="tag">{{tag}}
            </el-radio-button>
          </el-radio-group>
        </div>
        <p v-if="strArmyTitle.check" class="emptyWarn">请选择职务</p>
      </div>
    </div>
  </div>
</template>
<script>
import MultipleSelect from "../widgets/multipleSelect";
export default {
  components: {
    MultipleSelect
  },
  props:{
    'q':Object
  },
  data(){
    return {
      // 专业列表
      armyMajor: this.$store.state.PUBLISH.armyMajor,
      // 军龄列表
      armyAge: this.$store.state.PUBLISH.armyAge,
      // 职务列表
      armyRole: this.$store.state.PUBLISH.armyRole,
      // 军龄
      strArmyAge: {
        value: "",
        check: false
      },
      // 专业
      majorItems: {
        value: [],
        check: false
      },
      // 职务
      strArmyTitle: {
        value: "",
        check: false
      }
    }
  },
  mounted(){
    var q = this.$parent.q;
    // console.log('q',this.$parent.q,q)
    // console.log('b',this.$store.state.PUBLISH.armyAge)
    this.strArmyAge = {
      value: q.strArmyAge,
      check: false
    }
    if(q.strArmyMajor==null){
      this.majorItems = {
      value: [],
      check: false
      }
    }else{
      this.majorItems = {
      value: [q.strArmyMajor],
      check: false
      }
    }
    // console.log('q',this.$parent.q,q)
    this.strArmyTitle = {
      value: q.strArmyTitle,
      check: false
    }
    // console.log('q',this.strArmyAge,this.majorItems,this.strArmyTitle)
    // 初始化
    let armyMajor = this.armyMajor;
    armyMajor.forEach( a => {
      if(a.check === true) a.check = false;
    })
    this.armyMajor = armyMajor;
    let armyAge = this.armyAge;
    armyAge.forEach( a => {
      if(a.check === true) a.check = false;
    })
    this.armyAge = armyAge;
    let armyRole= this.armyRole;
    armyRole.forEach( a => {
      if(a.check === true) a.check = false;
    })
    this.armyRole = armyRole;
  },
  watch: {
    "$store.state.PUBLISH.jobInfo": {
      handler: function(){
        if(this.$store.state.PUBLISH.jobInfo){
          const info = this.$store.state.PUBLISH.jobInfo;
          // 军龄
          this.$set(this.strArmyAge, "value", info.strArmyAge);
          // 专业
          this.$set(this.majorItems, "value", info.strArmyMajor);
          // 职务
          this.$set(this.strArmyTitle, "value", info.strArmyTitle);
        }
      },
      immediate: true
    }
  },
  methods: {
    // 选择专业
    selectMajor(val){
      this.$set(this.majorItems, "value", val);
      this.$set(this.majorItems, "check", false);
    },

    // 返回数据
    returnVal(){
      const full = this.checkFill() ? false : true;
      return {
        strArmyAge: this.strArmyAge.value,
        majorItems: this.majorItems.value.join(),
        strArmyTitle: this.strArmyTitle.value,
        status: full
      }
    },
    // 取消报错
    changeCheck(type){
      console.log('y',type)
      this.$set(this[type], "check", false);
    },
    // 判断是否填写
    checkFill(){
      let hasEmpty = false;
      if(!this.strArmyAge.value){
        hasEmpty = true;
        this.$set(this.strArmyAge, "check", true);
      }
      if(this.majorItems.value.length === 0){
        hasEmpty = true;
        this.$set(this.majorItems, "check", true);
      }
      if(!this.strArmyTitle.value){
        hasEmpty = true;
        this.$set(this.strArmyTitle, "check", true);
      }

      return hasEmpty;
    },
  }
}
</script>
<style>
@import url("../../assets/css/module_publish.css");
</style>